import { useState, useEffect } from "react";
import { apiV2 } from "../api/axiosConfig";
import { useQuery } from "react-query";
import type { LegacyFacility } from "../features/map/hooks/useLegacyFacilitiesMarker";

export default function useLegacyFacilities() {
    const { data } = useQuery<LegacyFacility[]>(
        ["legacy-facilities-sites"],
        async () => {
            const res = await apiV2.get("ops/facilities-legacy");
            return res.data ?? [];
        },
    );

    return { facilities: data ?? [] };
}
